var _style, _desc, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRocketLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "189px",
    height: "261px",
    viewBox: "0 0 280 280",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    @keyframes dollar_t { 0% { transform: translate(0.499481px,-16.5px); } 50% { transform: translate(0.499481px,-23.7987px); } 100% { transform: translate(0.499481px,-16.5px); } }\n    @keyframes mflame_t { 0% { transform: translate(0.499481px,-16.5px); } 50% { transform: translate(0.499481px,-8.50759px); } 100% { transform: translate(0.499481px,-16.5px); } }\n    @keyframes lflame_t { 0% { transform: translate(0.499481px,-16.5px); } 46.6666% { transform: translate(0.499481px,5.4924px); } 100% { transform: translate(0.499481px,-16.5px); } }\n    @keyframes rflame_t { 0% { transform: translate(0.499481px,-16.5px); } 50% { transform: translate(0.499481px,-0.51037px); } 100% { transform: translate(0.499481px,-16.5px); } }\n  ")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "rocket") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "documentborder",
    d: "M198,179L82,179L82,42.0074C82,37.5854,85.585,34,90.0044,34L189.996,34C194.417,34,198,37.5837,198,42.0074Z",
    stroke: "#F8F9FA",
    strokeWidth: 16,
    fillRule: "nonzero",
    fill: "none",
    transform: "translate(0.499481,-16.5)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "document",
    d: "M102.953,61.6156C102.953,58.1696,105.737,55.376,109.188,55.376L170.032,55.376C173.476,55.376,176.267,58.1766,176.267,61.6156C176.267,65.0616,173.483,67.8552,170.032,67.8552L109.188,67.8552C105.744,67.8552,102.953,65.0546,102.953,61.6156ZM102.953,90.4735C102.953,87.0275,105.737,84.234,109.188,84.234L170.032,84.234C173.476,84.234,176.267,87.0345,176.267,90.4735C176.267,93.9195,173.483,96.7131,170.032,96.7131L109.188,96.7131C105.744,96.7131,102.953,93.9125,102.953,90.4735ZM102.953,120.111C102.953,116.665,105.741,113.872,109.202,113.872L126.341,113.872C129.793,113.872,132.591,116.672,132.591,120.111C132.591,123.557,129.802,126.351,126.341,126.351L109.202,126.351C105.751,126.351,102.953,123.55,102.953,120.111ZM102.953,149.749C102.953,146.303,105.741,143.51,109.202,143.51L126.341,143.51C129.793,143.51,132.591,146.31,132.591,149.749C132.591,153.195,129.802,155.989,126.341,155.989L109.202,155.989C105.751,155.989,102.953,153.188,102.953,149.749Z",
    fill: "#F8F9FA",
    transform: "translate(0.499481,-16.5)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "dollar",
    d: "M158.527,165.153L158.527,159.173C154.112,158.99,149.842,157.86,147.336,156.466L149.313,149.105C152.076,150.556,155.958,151.872,160.236,151.872C163.987,151.872,166.549,150.489,166.549,147.971C166.549,145.571,164.45,144.073,159.579,142.487C152.542,140.232,147.735,137.08,147.735,130.984C147.735,125.439,151.811,121.102,158.856,119.776L158.856,113.799L165.297,113.799L165.297,119.337C169.708,119.53,172.673,120.41,174.843,121.413L172.934,128.524C171.222,127.832,168.194,126.377,163.458,126.377C159.173,126.377,157.797,128.139,157.797,129.904C157.797,131.983,160.098,133.31,165.695,135.318C173.527,137.961,176.682,141.423,176.682,147.083C176.682,152.686,172.542,157.462,164.965,158.727L164.965,165.14L158.524,165.14L158.524,165.153Z",
    fill: "#F8F9FA",
    transform: "translate(0.499481,-16.5)",
    style: {
      animation: "dollar_t 2s linear infinite both"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "lfin",
    d: "M82,143L82,187L54.0095,187C45.1677,187,43.0688,181.931,49.3168,175.683Z",
    fill: "#F8F9FA",
    transform: "translate(0.499481,-16.5)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "rfin",
    d: "M197,143L229.683,175.683C235.933,181.933,233.833,187,224.991,187L197,187Z",
    fill: "#F8F9FA",
    transform: "translate(0.499481,-16.5)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "mflame",
    d: "M142,203C137.582,203,134,206.583,134,210.997L134,279.003C134,283.42,137.591,287,142,287L142,287C146.418,287,150,283.417,150,279.003L150,210.997C150,206.58,146.409,203,142,203Z",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    transform: "translate(0.499481,-16.5)",
    style: {
      animation: "mflame_t 1.6s linear infinite both"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "lflame",
    d: "M110,203C105.582,203,102,206.588,102,210.994L102,251.006C102,255.421,105.591,259,110,259L110,259C114.418,259,118,255.412,118,251.006L118,210.994C118,206.579,114.409,203,110,203Z",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    transform: "translate(0.499481,-16.5)",
    style: {
      animation: "lflame_t 1.5s linear infinite both"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "rflame",
    d: "M174,203C169.582,203,166,206.578,166,210.992L166,227.008C166,231.422,169.591,235,174,235L174,235C178.418,235,182,231.422,182,227.008L182,210.992C182,206.578,178.409,203,174,203Z",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    transform: "translate(0.499481,-16.5)",
    style: {
      animation: "rflame_t 1s linear infinite both"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketLogo);
export default __webpack_public_path__ + "static/media/rocket-logo.a937371f671e9d0092ef0466a08f50be.svg";
export { ForwardRef as ReactComponent };